"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Occ_SwitcherLabelBall = exports.Occ_SwitcherLabel = exports.Occ_SwitcherInput = exports.Occ_Switcher = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Occ_Switcher = (0, _styledComponents["default"])('div')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n"])));
exports.Occ_Switcher = Occ_Switcher;
var Occ_SwitcherLabel = (0, _styledComponents["default"])('label')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    border: 1px solid var(--color-gray-500);\n    border-radius: 50px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    box-sizing: content-box;\n    padding: ", ";\n    position: relative;\n    height: ", ";\n    width: ", ";\n"])), function (props) {
  if (props.swsize === 'medium') {
    return '5px';
  } else if (props.swsize === 'large') {
    return '6px';
  } else {
    return '4px';
  }
}, function (props) {
  if (props.swsize === 'medium') {
    return '22px';
  } else if (props.swsize === 'large') {
    return '18px';
  } else {
    return '18px';
  }
}, function (props) {
  if (props.swsize === 'medium') {
    return '42px';
  } else if (props.swsize === 'large') {
    return '46px';
  } else {
    return '35px';
  }
});
exports.Occ_SwitcherLabel = Occ_SwitcherLabel;
var Occ_SwitcherLabelBall = (0, _styledComponents["default"])('div')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    background-color: var(--color-gray-500);\n    border-radius: 50%;\n    position: absolute;\n    top: 3px;\n    left: 2px;\n    height: ", ";\n    width: ", ";\n    transform: translateX(0px);\n    transition: transform 0.2s linear;\n"])), function (props) {
  if (props.swsize === 'medium') {
    return '25px';
  } else if (props.swsize === 'large') {
    return '23px';
  } else {
    return '20px';
  }
}, function (props) {
  if (props.swsize === 'medium') {
    return '25px';
  } else if (props.swsize === 'large') {
    return '23px';
  } else {
    return '20px';
  }
});
exports.Occ_SwitcherLabelBall = Occ_SwitcherLabelBall;
var Occ_SwitcherInput = (0, _styledComponents["default"])('input')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    z-index: 1;\n    opacity: 0;\n    position: absolute;\n    left: 12px;\n    bottom: 5px;\n    transform: ", ";\n    cursor: pointer;\n\n    &:checked {\n        + ", " ", " {\n            transform: ", ";\n            background-color: var(--color-base-white);\n        }\n\n        + ", " {\n            background-color: ", ";\n            border: ", ";\n        }\n    }\n"])), function (props) {
  if (props.swsize === 'medium') {
    return 'scale(2.5)';
  } else if (props.swsize === 'large') {
    return 'scale(2.8)';
  } else {
    return 'scale(1.8)';
  }
}, Occ_SwitcherLabel, Occ_SwitcherLabelBall, function (props) {
  if (props.swsize === 'medium') {
    return 'translateX(22px)';
  } else if (props.swsize === 'large') {
    return 'translateX(30px)';
  } else {
    return 'translateX(18px)';
  }
}, Occ_SwitcherLabel, function (props) {
  if (props.color === 'secondary') {
    return 'var(--color-secondary)';
  } else {
    return 'var(--color-primary)';
  }
}, function (props) {
  if (props.color === 'secondary') {
    return '1px solid var(--color-secondary)';
  } else {
    return '1px solid var(--color-primary)';
  }
});
exports.Occ_SwitcherInput = Occ_SwitcherInput;